interface ImageUrlProps {
  image: string | null;
  // size?: ImageSize;
  width?: number;
  height?: number;
}

export const getImageUrl = ({ image }: ImageUrlProps): string | null => {
  if (!process.env.REACT_APP_IMAGE_URL || !image) {
    return null;
  }

  let imgUrl = '';
  // image je object GQL.IImage
  // if (typeof image !== 'string' && image.file) {
  //     imgUrl = image.file;
  // }
  // image je string (url obrázku)
  if (typeof image === 'string') {
    imgUrl = image;
  }

  // velikost obrázku
  // if (size) {
  //   imgUrl = imgUrl.substr(0, imgUrl.lastIndexOf('.'))
  //     + `_${size.toString()}.`
  //     + imgUrl.substr(imgUrl.lastIndexOf('.') + 1);
  // }

  // resize
  // if (width && height) {
  //   imgUrl = imgUrl.substr(0, imgUrl.lastIndexOf('.'))
  //     + `_${width}x${height}.`
  //     + imgUrl.substr(imgUrl.lastIndexOf('.') + 1);
  // }

  // console.log('Image process.env', process.env);
  // console.log('Image imageUrl', imageUrl);

  // return `${imageUrl}/${imgUrl}`;
  return `${process.env.REACT_APP_IMAGE_URL}/${imgUrl}`;

  // return noimage;
};
